import { PurchaseOrderStatus, purchaseOrderStatusName, } from '../../constants/purchase-order-status.js';
/**
 * The canonical list of PO header statuses a receive may be posted against. The API header
 * check, the temporal activity, and the web action button all derive their gate from this
 * list — by id or by display name — so a status change here propagates everywhere and
 * cannot be honored by one gate while rejected by another.
 */
export const RECEIVABLE_PURCHASE_ORDER_STATUS_IDS = [
    PurchaseOrderStatus.ISSUED,
    PurchaseOrderStatus.SHIPPED,
    PurchaseOrderStatus.PARTIALLY_RECEIVED,
];
const RECEIVABLE_IDS = new Set(RECEIVABLE_PURCHASE_ORDER_STATUS_IDS);
export function isPurchaseOrderReceivableStatus(statusId) {
    return RECEIVABLE_IDS.has(statusId);
}
const STATUS_ID_TO_NAME = {
    [PurchaseOrderStatus.DRAFT]: purchaseOrderStatusName.DRAFT,
    [PurchaseOrderStatus.ISSUED]: purchaseOrderStatusName.ISSUED,
    [PurchaseOrderStatus.SHIPPED]: purchaseOrderStatusName.SHIPPED,
    [PurchaseOrderStatus.PARTIALLY_RECEIVED]: purchaseOrderStatusName.PARTIALLY_RECEIVED,
    [PurchaseOrderStatus.RECEIVED]: purchaseOrderStatusName.RECEIVED,
    [PurchaseOrderStatus.CANCELLED]: purchaseOrderStatusName.CANCELLED,
};
/** Display names of the ids above — derived, never re-listed. */
export const RECEIVABLE_PURCHASE_ORDER_STATUS_NAMES = new Set(RECEIVABLE_PURCHASE_ORDER_STATUS_IDS.map((statusId) => STATUS_ID_TO_NAME[statusId]));
export function isPurchaseOrderReceivableStatusName(statusName) {
    return statusName != null && RECEIVABLE_PURCHASE_ORDER_STATUS_NAMES.has(statusName);
}
//# sourceMappingURL=receivable-status.js.map